function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var unsubscribeDelay = 5000; // ms

var CacheItem =
/*#__PURE__*/
function () {
  /**
   * Creates a CacheItem instance
   * @param {string} rid Resource ID
   * @param {function} unsubscribe Unsubscribe callback
   */
  function CacheItem(rid, unsubscribe) {
    _classCallCheck(this, CacheItem);

    this.rid = rid;
    this._unsubscribe = unsubscribe;
    this.type = null;
    this.item = null;
    this.direct = 0;
    this.indirect = 0;
    this.subscribed = false;
    this.promise = null;
  }

  _createClass(CacheItem, [{
    key: "setSubscribed",
    value: function setSubscribed(isSubscribed) {
      this.subscribed = isSubscribed;

      if (!isSubscribed && this.unsubTimeout) {
        clearTimeout(this.unsubTimeout);
        this.unsubTimeout = null;
      }

      return this;
    }
  }, {
    key: "setPromise",
    value: function setPromise(promise) {
      if (!this.item) {
        this.promise = promise;
      }

      return promise;
    }
  }, {
    key: "setItem",
    value: function setItem(item, type) {
      this.item = item;
      this.type = type;
      this.promise = null;

      this._checkUnsubscribe();

      return this;
    }
  }, {
    key: "setType",
    value: function setType(modelType) {
      this.type = modelType;
      return this;
    }
  }, {
    key: "addDirect",
    value: function addDirect() {
      if (this.unsubTimeout) {
        clearTimeout(this.unsubTimeout);
        this.unsubTimeout = null;
      }

      this.direct++;
    }
  }, {
    key: "removeDirect",
    value: function removeDirect() {
      this.direct--;

      if (this.direct < 0) {
        throw "Direct count reached below 0";
      }

      if (this.subscribed) {
        this._checkUnsubscribe();
      } else {
        // The subscription might be stale and should then be removed directly
        this._unsubscribe(this);
      }
    }
  }, {
    key: "_checkUnsubscribe",
    value: function _checkUnsubscribe() {
      var _this = this;

      if (!this.subscribed || this.direct || this.unsubTimeout) {
        return;
      }

      this.unsubTimeout = setTimeout(function () {
        return _this._unsubscribe(_this);
      }, unsubscribeDelay);
    }
  }, {
    key: "addIndirect",
    value: function addIndirect() {
      var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.indirect += n;
    }
  }, {
    key: "removeIndirect",
    value: function removeIndirect() {
      var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.indirect -= n;

      if (this.indirect < 0) {
        throw "Indirect count reached below 0";
      }
    }
  }]);

  return CacheItem;
}();

export default CacheItem;